module.exports = __WEBPACK_EXTERNAL_MODULE__56003__;